import { render } from "./ONasPage.vue?vue&type=template&id=af253cda&scoped=true"
import script from "./ONasPage.vue?vue&type=script&lang=js"
export * from "./ONasPage.vue?vue&type=script&lang=js"

import "./ONasPage.vue?vue&type=style&index=0&id=af253cda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af253cda"]])

export default __exports__